import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";
import CanvasAnimation from "../../Components/CanvasItems";

const EmptyView = ({ navigate_link, title, subtitle, item }) => {
    const { t } = useLanguage()
    const navigate = useNavigate()


    const navigateToNewView = () => {
        navigate(navigate_link)
    }

    return (
        <div className="empty_cont fade-in">
            <div className="icon_cont">
                <p className="icon_cont_title">{title}</p>
                <p className="icon_cont_subtitle">{subtitle}</p>

                {item != "" && (
                    <div className="canvas_anim_empty_cont">
                        <CanvasAnimation type={item}/>
                    </div>
                )}
            </div>
            <div className="btn_cont">
                <button className="connect_email_btn" onClick={navigateToNewView}><i className="fa-solid fa-plus"></i> {t.create}</button>
            </div>
        </div>
    )
}

export default EmptyView